export default __webpack_public_path__ + "static/media/bakun_view.4fb22818.png";